import Vue from 'vue'
import Router, { RouterOptions, RouteConfig } from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

import DeviceDetails from '@/components/dialogs/DeviceDetails.vue'
import DeviceReboot from '@/components/dialogs/DeviceReboot.vue'
import DeviceReset from '@/components/dialogs/DeviceReset.vue'
import DeviceRename from '@/components/dialogs/DeviceRename.vue'
import DeviceSetEdid from '@/components/dialogs/DeviceSetEdid.vue'

import MatrixRemapDialog from '@/components/dialogs/MatrixRemapDialog.vue'

import VwCreate from '@/components/dialogs/VwCreate.vue'
import VwRename from '@/components/dialogs/VwRename.vue'
import VwResize from '@/components/dialogs/VwResize.vue'
import VwVendor from '@/components/dialogs/VwVendor.vue'
import VwDetails from '@/components/dialogs/VwDetails.vue'
import VwDelete from '@/components/dialogs/VwDelete.vue'
import VwRxMapper from '@/components/dialogs/VwRxMapper.vue'
import VwTxMapper from '@/components/dialogs/VwTxMapper.vue'
import VwShowDisplayIndex from '@/components/dialogs/VwShowDisplayIndex.vue'

import SysUI from '@/components/sys/UI.vue'
import SysBasicInfo from '@/components/sys/BasicInfo.vue'
import SysNetwork from '@/components/sys/Network.vue'
import SysMaintenance from '@/components/sys/Maintenance.vue'

import SysUILangDialog from '@/components/dialogs/SysLangSelector.vue'
import SysNetworkEditDialog from '@/components/dialogs/SysNetworkEdit.vue'

import OsdSelector from '@/components/dialogs/OsdSelector.vue'
import OsdDelete from '@/components/dialogs/OsdDelete.vue'
import OsdEditor from '@/components/dialogs/OsdEditor.vue'
import ImgSelector from '@/components/dialogs/ImgSelector.vue'
import ImgEditor from '@/components/dialogs/ImgEditor.vue'
import ImgDelete from '@/components/dialogs/ImgDelete.vue'

import PresetCreate from '@/components/dialogs/PresetCreate.vue'
import PresetDetails from '@/components/dialogs/PresetDetails.vue'
import PresetRename from '@/components/dialogs/PresetRename.vue'
import PresetDelete from '@/components/dialogs/PresetDelete.vue'

Vue.use(Router)
// ====================================
// Types
// ====================================

// ====================================
// Router & Query
// ====================================
export type qkey_t = 'rotate_flip' | 'bezel' |
'osd_selector' | 'osd_edit' | 'osd_create' | 'osd_delete' |
'img_selector' | 'img_edit' | 'img_create' | 'img_delete'

/** A helper class to manipulate Router's query  */
export class QueryManipulator {
  static add (key: qkey_t, val: string): void {
    const newQuery = Object.assign({}, router.currentRoute.query, {[key]: val})
    router.push({ query: newQuery })
  }
  static del (key: qkey_t, replace: boolean = false): void {
    const newQuery = Object.assign({}, router.currentRoute.query)
    delete newQuery[key]
    if (replace) {
      router.replace({ query: newQuery })
    } else {
      router.push({ query: newQuery })
    }
  }
  static delMultiple (...keys: qkey_t[]) {
    for (const k of keys) {
      QueryManipulator.del(k, true)
    }
  }
  static get (key: qkey_t): string {
    return router.currentRoute.query[key]
  }
}

function generateOsdRouters (namePrefix: string): RouteConfig[] {
  const p = namePrefix
  return [
    {
      path: 'osd_selector', name: `${p}_osd`, component: OsdSelector,
      children: [
        {
          path: 'create', name: `${p}_osd_create`, component: OsdEditor,
          children: [
            {
              path: 'img_selector', name: `${p}_osd_create_img`, component: ImgSelector,
              children: [
                { path: 'create', name: `${p}_osd_create_img_create`, component: ImgEditor },
                { path: 'delete/:imgid', name: `${p}_osd_create_img_delete`, component: ImgDelete },
                { path: 'edit/:imgid', name: `${p}_osd_create_img_edit`, component: ImgEditor },
              ]
            }
          ]
        },
        {
          path: 'delete/:osdid', name: `${p}_osd_delete`, component: OsdDelete,
        },
        {
          path: 'edit/:osdid', name: `${p}_osd_edit`, component: OsdEditor,
          children: [
            {
              path: 'img_selector', name: `${p}_osd_edit_img`, component: ImgSelector,
              children: [
                { path: 'create', name: `${p}_osd_edit_img_create`, component: ImgEditor },
                { path: 'delete/:imgid', name: `${p}_osd_edit_img_delete`, component: ImgDelete },
                { path: 'edit/:imgid', name: `${p}_osd_edit_img_edit`, component: ImgEditor },
              ]
            }
          ]
        }
      ]
    }
  ]
}

// ====================================
// Router
// ====================================
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    { path: '/login_page', name: 'login', component: Login },
    { path: '/matrix', name: 'matrix', component: () => import('@/views/Matrix.vue'),
      children: [
        { path: 'rename/:mac', name: 'matrix_rename', component: DeviceRename },
        { path: 'remap/:master_mac', name: 'matrix_remap', component: MatrixRemapDialog,
          children: [
            { path: 'rename/:mac', name: 'matrix_remap_rename', component: DeviceRename }
          ]
        }
      ]
    },
    {
      path: '/device_list', name: 'devlst', component: () => import('@/views/DeviceList.vue'),
      children: [
        { path: 'rename/:mac', name: 'devlst_rename', component: DeviceRename },
        { path: ':master_mac', name: 'devlst_details', component: DeviceDetails,
        children: [
          { path: 'reboot/:mac', name: 'devlst_details_reboot', component: DeviceReboot },
          { path: 'rename/:mac', name: 'devlst_details_rename', component: DeviceRename },
          { path: 'reset/:mac', name: 'devlst_details_reset', component: DeviceReset },
          { path: 'edid/:mac', name: 'devlst_details_edid', component: DeviceSetEdid },
        ] },
      ]
    },
    {
      path: '/vw', name: 'vwlst', component: () => import('@/views/Vw.vue'),
      children: [
        { path: 'create', name: 'vwlst_create', component: VwCreate },
        { path: 'rename/:vwid', name: 'vwlst_rename', component: VwRename },
        { path: 'delete/:vwid', name: 'vwlst_delete', component: VwDelete },
        { path: ':vwid', name: 'vwlst_details', component: VwDetails,
        children: [
          { path: 'rename', name: 'vwlst_details_rename', component: VwRename },
          { path: 'resize', name: 'vwlst_details_resize', component: VwResize },
          { path: 'resize', name: 'vwlst_details_vendor', component: VwVendor },
          {
            path: 'rxmap', name: 'vwlst_details_rxmap', component: VwRxMapper,
            children: generateOsdRouters('vwlst_details_rxmap').concat([
              { path: 'rename/:mac', name: 'vwlst_details_rxmap_rename', component: DeviceRename }
            ])
          },
          {
            path: 'txmap', name: 'vwlst_details_txmap', component: VwTxMapper,
            children: [
              { path: 'rename/:mac', name: 'vwlst_details_txmap_rename', component: DeviceRename }
            ]
          },
          { path: 'showidx', name: 'vwlst_details_showidx', component: VwShowDisplayIndex },
        ] },
      ]
    },
    {
      path: '/preset', name: 'preset', component: () => import('@/views/Preset.vue'),
      children: [
        { path: 'create', name: 'preset_create', component: PresetCreate },
        { path: 'rename/:presetid', name: 'preset_rename', component: PresetRename },
        { path: 'delete/:presetid', name: 'preset_delete', component: PresetDelete },
        { path: 'details/:presetid', name: 'preset_details', component: PresetDetails },
      ]
    },
    { path: '/sys', name: 'sys', redirect: '/sys/ui' },
    {
      path: '/sys', name: '__meta_sys', component: () => import('@/views/Sys.vue'),
      children: [
        { path: 'ui', name: 'sys_ui', component: SysUI,
        children: [
          { path: 'lang', name: 'sys_ui_lang', component: SysUILangDialog }
        ] },
        { path: 'basic_info', name: 'sys_basicinfo', component: SysBasicInfo },
        { path: 'network', name: 'sys_network', component: SysNetwork,
        children: [
          { path: 'edit', name: 'sys_network_edit', component: SysNetworkEditDialog }
        ] },
        { path: 'maintenance', name: 'sys_maintenance', component: SysMaintenance },
      ]
    },
    { path: '*', redirect: '/' },
  ],
})

console.log('INIT ROUTER', router)

export default router
